import { render, staticRenderFns } from "./FocoRoutingSection.vue?vue&type=template&id=1886e89c&scoped=true&"
import script from "./FocoRoutingSection.vue?vue&type=script&lang=js&"
export * from "./FocoRoutingSection.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/radio.css?vue&type=style&index=0&lang=css&"
import style1 from "./FocoRoutingSection.vue?vue&type=style&index=1&id=1886e89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886e89c",
  null
  
)

export default component.exports